import { LogoutFlowEvents, LogoutFlowStates } from './LogoutFlow.constants';
export const logoutFlowReducer = (state, event) => {
    if (event === LogoutFlowEvents.Close) {
        return LogoutFlowStates.Close;
    }
    if (state === LogoutFlowStates.Init) {
        if (event === LogoutFlowEvents.VerifyCanLogout) {
            return LogoutFlowStates.VerifyingCanLogout;
        }
        return state;
    }
    if (state === LogoutFlowStates.VerifyingCanLogout) {
        if (event === LogoutFlowEvents.ShowConfirmationModal) {
            return LogoutFlowStates.ShowingConfirmationModal;
        }
        if (event === LogoutFlowEvents.Logout) {
            return LogoutFlowStates.LoggingOut;
        }
        return state;
    }
    if (state === LogoutFlowStates.ShowingConfirmationModal) {
        if (event === LogoutFlowEvents.Logout) {
            return LogoutFlowStates.LoggingOut;
        }
        return state;
    }
    if (state === LogoutFlowStates.LoggingOut) {
        return state;
    }
    throw new Error(`Invalid logout state! state: ${state} event : ${event}`);
};
